var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('BannerComp'),_c('IntroComp'),_c('ProcesoComp'),_c('ProductosComp'),_c('v-container',[_c('BotonFlotanteComp')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }